module.exports = __webpack_public_path__ + "static/img/gasMonitor.1db231ec.png";